import BonusDisplayPanel from './BonusDisplayPanel';

export default BonusDisplayPanel;
